<template>
  <div class="addCommondity">
    <div class="goodsManageDetailPage">
      <div class="banner">
        <img src="../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <!-- <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div> -->
        <div class="breadcrumb_item">促销优惠&市场活动</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">市场活动管理</div>
      </div>

      <div class="main_content">
        <div class="block">
          <h1><span class="mark">*</span>指定样式内容</h1>
          <div class="radio_box">
            <van-radio-group v-model="formData.conttype" direction="horizontal">
              <van-radio :name="1">大图内容段</van-radio>
              <van-radio :name="2">视频内容段</van-radio>
              <van-radio :name="3">文字内容段</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div
          class="block"
          v-if="formData.conttype == 1 || formData.conttype == 2"
        >
          <h1><span class="mark">*</span>图片或者视频封面</h1>
          <p class="red">JPG或者PNG格式，尺寸比例为500*750像素</p>
          <div class="img_box">
            <van-uploader
              v-model="fileList"
              @delete="formData.picurl = ''"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>

        <div class="block" v-if="formData.conttype == 2">
          <div class="video_box">
            <van-uploader
              @click-upload="clickUpload(item.id)"
              :before-read="beforeReadVideo"
              :after-read="addVideoContent"
              :max-count="1"
              class="flex-rowc"
              accept="multiple"
            >
              <video :src="formData.videourl" controls></video>
            </van-uploader>
          </div>
        </div>
        <div class="block" v-if="formData.conttype == 3">
          <h1><span class="mark">*</span>详情内容：</h1>
          <div class="input_box">
            <van-field
              v-model="formData.details"
              type="textarea"
              placeholder="输入详情内容"
            />
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>排序：</h1>
          <div class="input_box">
            <van-field v-model="formData.sortno" placeholder="请输入排序" />
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">确认</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
      <!-- <div class="return-fixd">
        
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  uploadPosterImage,
  getUploadToken,
  encryptstringview,
} from "../../api/api";
import {
  getActivityDetailDetail,
  editActivityDetail,
  addActivityDetail,
} from "../../api/shop";
export default {
  name: "activityDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      isShow: false,
      popupType: 1,
      popupDate: 1,

      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      formData: {
        id: "",
        actid: "",
        conttype: "",
        picurl: "",
        videourl: "",
        details: "",
        sortno: "",
      },
      fileList: [],
      provinceList: [],
      shopList: [],
      shopcodestr: "",
      currentDate: new Date(),
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, actid } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.formData.actid = actid;
        if (id != "") {
          this.getActivityDetailDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 获取活动详情
    getActivityDetailDetail(id) {
      getActivityDetailDetail({ id }).then((res) => {
        this.formData.conttype = parseInt(res.conttype);
        this.formData.picurl = res.picurl;
        this.fileList.push({ url: this.baseUrl + res.picurl });
        this.formData.city = res.city;
        this.formData.videourl = res.videourl ? res.videourl : "";
        this.formData.details = res.details;
        this.formData.sortno = res.sortno;
      });
    },

    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let { isType } = this;
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          console.log("当前图片的宽高:" + width, height);
          if (isType == 1) {
            if (width == 500 && height == 500) {
              reject(true);
            } else {
              resolve(false);
            }
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          this.formData.actcover = res.code;
          Toast.clear();
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
          Toast.clear();
        }
      });
    },

    // 3、新增视频内容
    // 上传之前
    beforeReadVideo(file) {
      const imgformat = /video\/(mp4)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传视频");
        return false;
      }
      return true;
    },
    addVideoContent(e) {
      getUploadToken().then((res) => {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", e.file);
        const config = {
          onUploadProgress: this.setUploadProgress, // 将方法绑定到上传进度事件上
        };
        return new Promise((resolve, reject) => {
          axios
            .post("https://upload.vwingist.com/", formData, config)
            .then((response) => {
              // 请求成功的处理
              if (response.status === 200) {
                resolve(response.data);
                //返回数据根据结果进行相应的处理
                this.formData.videourl = res.host + "/" + res.key;
              } else {
                reject("请求失败");
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      });
    },
    // 设置上传进度
    setUploadProgress(event) {
      // 进度处理逻辑
      const progress = Math.round((event.loaded / event.total) * 100);
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: `上传:${progress}%`,
      });
      if (progress == 100) {
        toast.clear();
      }
      // console.log("上传进度：", progress, "%");
    },

    // 返回上一页
    handleReturn() {
      history.back();
    },

    // 提交数据
    query() {
      let { formData } = this;
      if (formData.conttype == "") {
        this.$toast("请选择指定样式内容");
        return;
      }
      if (formData.conttype == 1 && formData.picurl == "") {
        this.$toast("请上传图片或者视频封面");
        return;
      }
      if (formData.conttype == 2 && formData.videourl == "") {
        this.$toast("请上传视频");
        return;
      }
      if (formData.conttype == 3 && formData.details == "") {
        this.$toast("请输入文字内容段");
        return;
      }

      if (formData.id == "") {
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        addActivityDetail(formData).then((res) => {
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message);
          }
        });
      } else {
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        editActivityDetail(formData).then((res) => {
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageDetailPage {
  padding-bottom: 380px;
  .main_content {
    font-size: 30px;
    color: #444444;
    h1 {
      text-align: center;
      font-weight: 400;
      margin-bottom: 35px;
    }
    input {
      text-align: center;
    }
    .block {
      margin-bottom: 100px;
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
    }
    .input_box {
      margin-bottom: 30px;
    }
    p {
      line-height: 30px;
      font-size: 22px;
      color: #ff0012;
      text-align: center;
    }
    .video_box {
      width: 400px;
      margin: auto;
      video {
        width: 100%;
      }
    }
  }
}
</style>